export default {
    bacs: (state) => state,
    firstName: (state) => state.firstName,
    lastName: (state) => state.lastName,
    accountNumber: (state) => state.accountNumber,
    sortCode: (state) => state.sortCode,
    paymentMethodId: (state) => state.paymentMethodId,
}
